import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiLinks } from '../../../app.api-links';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor(private http: HttpClient) {}

  changeLanguage(idClient: number, langCode: string): Observable<void> {
    const paramsHttp: HttpParams = new HttpParams().set('langCode', langCode);

    return this.http.post<void>(`${ApiLinks.client}/${idClient}/change-language`, undefined, { params: paramsHttp });
  }
}
